interface BuildDeviceDetailsPathParams {
  serialNumber: string;
  linkId?: string | number | null;
  isAdminView?: boolean;
}

export function isValidLinkId(
  linkId?: string | number | null,
): linkId is string | number {
  return (
    linkId !== undefined &&
    linkId !== null &&
    linkId !== "" &&
    String(linkId) !== "undefined" &&
    String(linkId) !== "null"
  );
}

/**
 * Builds the device details path. Admins use /all-devices without linkId;
 * dealers use /devices with a real linkId when available.
 */
export function buildDeviceDetailsPath({
  serialNumber,
  linkId,
  isAdminView = false,
}: BuildDeviceDetailsPathParams): string {
  const basePath = isAdminView ? "/all-devices/details" : "/devices/details";
  const params = new URLSearchParams({ serialNumber });

  if (isValidLinkId(linkId)) {
    params.set("linkId", String(linkId));
  }

  return `${basePath}?${params.toString()}`;
}
